import Vue from 'vue';
//import Login from "../views/login/Login";
//import resolveRejected from "../services/resolveRejected";
//Vue.use(resolveRejected);

export default () => {
    const setCookie = function(cname, cvalue, seconds) {
        var d = new Date();
        d.setTime(d.getTime() + (seconds*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    const getCookie = function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    const deleteCookie = function ( name, path, domain ) {
        if(name) {
            document.cookie = name + "=" +
                ((path) ? ";path="+path:"")+
                ((domain)?";domain="+domain:"") +
                ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    };
    const handleReject = function(){
        deleteCookie('access_token');
        deleteCookie('refresh_token');
        deleteCookie('access_exp_time');
        this.$store.commit('navigator/reset');
    };
    //
    Vue.prototype.$handleReject = handleReject;
    Vue.prototype.$setCookie = setCookie;
    Vue.prototype.$getCookie = getCookie;
    Vue.prototype.$deleteCookie = deleteCookie;
};

